import { csrfToken } from './request'

export default class SessionController {
	static logout() {
		return fetch(`/sign_out`, {
			method: 'DELETE',
			headers: { 'X-CSRF-Token': csrfToken() },
			credentials: 'same-origin',
		})
	}
}
